<div  *ngIf="!(pdfPageVisibleSubject | async)"
      class="background-lightgray opacity-half margin-auto"
      [ngStyle]="{
          height:(heightObs | async) + 'px',
          width:(widthObs | async) + 'px',
          'margin-bottom':PAGE_SPACING +'px'
      }"
></div>

<a (click)="pageSelected()">

    <div
      *ngIf="(pdfPageVisibleSubject | async)"
      class="position-relative margin-auto"
      [ngStyle]="{
        height:(heightObs | async) + 'px',
        width:(widthObs| async) + 'px',
        'margin-bottom':PAGE_SPACING +'px'
      }"
    >

      <p  class="position-top-left-small">
        {{ ((pdfPageInfoSubject | async).realPageIdx) }}
      </p>
      <img  [src]="imgPathObs | async" 
            class="padding-small border-gray background-white border-radius-smaller"
            [ngStyle]="styleObs | async"
            [height]="heightObs | async"
            [width]="widthObs | async"
      >
      
      <div
        #divOverlay
        class="div-overlay"
        [ngClass]="{
          'div-overlay-hover': !!(imgPathObs | async),
          'div-overlay-selected': (isSelectedObs | async)
        }"
      >
        <mat-spinner
          *ngIf="!(imgPathObs | async)"
          diameter="60"
          class="page-spinner"
        ></mat-spinner>
      </div>
    </div>
</a>